
<div class="conf3dModal">
  <div class="conf-show-extint-panel">
    <div class="conf-back-button" (click)="show_model_view('showModal')">
      <img src="{{ confAWSUrlStr }}/common/close_selected.svg" alt="close" />
    </div>

    <div class="conf-ext-img" [ngClass]="
        isExterior == 'exterior_selected'
          ? 'conf-ext-active'
          : 'conf-ext-inactive'
      " (click)="showExtInt('exterior')">
      <img src="{{ confAWSUrlStr }}/common/{{ isExterior }}.svg" alt="exterior" />
    </div>

    <div class="conf-int-img" [ngClass]="
        isInterior == 'interior_selected'
          ? 'conf-int-active'
          : 'conf-int-inactive'
      " (click)="showExtInt('interior')">
      <img src="{{ confAWSUrlStr }}/common/{{ isInterior }}.svg" alt="interior" />
    </div>

    <div class="conf-door-img" (click)="showExtInt('door')" *ngIf="isDoorVisible">
      <img src="{{ confAWSUrlStr }}/common/door_unselected.svg" alt="door" />
    </div>

    <div class="conf-light-img" (click)="showExtInt('light')" *ngIf="isLightVisible">
      <img src="{{ confAWSUrlStr }}/common/light_unselected.svg" alt="light" />
    </div>

    <div class="conf-color-img" (click)="showExtInt('color')" *ngIf="isColorVisible">
      <img src="{{ confAWSUrlStr }}/common/color_unselected.svg" alt="color" />
    </div>
  </div>
</div>
    <div class="conf3dModal_container" id="one3d"></div>

